import { render } from "./BaseTruncatedString.vue?vue&type=template&id=f55cb1d8"
import script from "./BaseTruncatedString.vue?vue&type=script&lang=js"
export * from "./BaseTruncatedString.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__